import { UUID } from "../generic/uuid";
import {
  createVintageDtoFromAnalyticVintageModel,
  VintageModel,
} from "./vintage";
import {
  B2bMarketPriceModel,
  createB2BMarketPriceDtoFromAnalyticB2BMarketPriceModel,
} from "./b2bMarketPrice";
import { VintageProductDto } from "@vini-wine/core-dtos";

export interface VintageProductModel extends UUID {
  // transform
  milliliters: number;

  // available includes
  vintage?: VintageModel;
  b2bMarketPrice?: B2bMarketPriceModel;
}

export const createVintageProductDtoFromAnalyticVintageProductModel = (
  vintageProduct: VintageProductModel,
): VintageProductDto => {
  return {
    uuid: vintageProduct.uuid,
    milliliters: vintageProduct.milliliters,
    vintage: vintageProduct.vintage
      ? createVintageDtoFromAnalyticVintageModel(vintageProduct.vintage)
      : undefined,
    b2bMarketPrice: vintageProduct.b2bMarketPrice
      ? createB2BMarketPriceDtoFromAnalyticB2BMarketPriceModel(
          vintageProduct.b2bMarketPrice,
        )
      : undefined,
  };
};
